// The variable process.env.NODE_ENV
// is set to 'production' when running `npm run build`
// but set to 'development' when running `npm start`
const production_environment = process.env.NODE_ENV === 'production';

// Determine which stage we're deploying to
// This is set during the CDK build process
const stage = process.env.DEPLOY_STAGE || 'dev';

// Backend URLs by stage
// Set LOCAL_BACKEND=true when running npm start to use local backend on port 3001
const useLocalBackend = process.env.LOCAL_BACKEND === 'true';

const backendUrls = {
	local: {
		adminApi: 'http://localhost:3001/admin',
		publicApi: 'http://localhost:3001',
	},
	dev: {
		adminApi: 'https://admin-api.dev.tuutuum.se/admin',
		publicApi: 'https://api.dev.tuutuum.se',
	},
	prod: {
		adminApi: 'https://admin-api.tuutuum.se/admin',
		publicApi: 'https://api.tuutuum.se',
	},
};

const config = {
	PRODUCTION_ENVIRONMENT: production_environment,
	// In development (local), check LOCAL_BACKEND env var
	// In production (deployed), use the stage-specific backend
	TUUTUUM_BACKEND_PUBLIC_API: production_environment 
		? backendUrls[stage].publicApi 
		: (useLocalBackend ? backendUrls.local.publicApi : backendUrls.dev.publicApi),
	TUUTUUM_BACKEND_ADMIN_API: production_environment 
		? backendUrls[stage].adminApi 
		: (useLocalBackend ? backendUrls.local.adminApi : backendUrls.dev.adminApi),
	// In local dev, use localhost.tuutuum.se domain to enable cookie sharing between sites
	// (requires adding "127.0.0.1 localhost.tuutuum.se public.localhost.tuutuum.se" to /etc/hosts)
	TUUTUUM_QR_SITE:	production_environment 
		? (stage === 'prod' ? 'https://public.tuutuum.se' : 'https://public.dev.tuutuum.se')
		: 'http://public.localhost.tuutuum.se:9000',

	googleMapsKey:		process.env.REACT_APP_GOOGLE_MAPS_KEY || "AIzaSyCe0BecIcHXVRCSpkGtP1sR017kdcKpse4",
	googleClientId:		process.env.REACT_APP_GOOGLE_CLIENT_ID || '565987596167-kcfk7vtunmobk3ukgt8r4caef6arh4gs.apps.googleusercontent.com',
	googleAnalyticsId:	process.env.REACT_APP_GOOGLE_ANALYTICS_ID,
	recaptchaSiteKey:	process.env.REACT_APP_RECAPTCHA_SITE_KEY,
};

// Debug output
console.log('[Config] Environment:', {
	production: production_environment,
	stage: stage,
	useLocalBackend: useLocalBackend,
	adminApi: config.TUUTUUM_BACKEND_ADMIN_API,
	publicApi: config.TUUTUUM_BACKEND_PUBLIC_API,
	qrSite: config.TUUTUUM_QR_SITE
});

export default config;
